import { fromBackendToClientAngle } from '@/catalog/components/CatalogSidebar/CatalogFilters/FiltersPanel/HueAngleFilter/HueAngleFilter.utils';
import { angleToFineStepHue } from '@/color/helpers/hueUtils';
import { radianToDegree } from '@/color/types/Angle';
export default class MunsellMetric {
    hueAngle;
    fineStepHue;
    constructor(data) {
        this.hueAngle = data.hueAngle;
        this.fineStepHue = angleToFineStepHue(this.getHueAngle());
    }
    getHueAngle = () => {
        return fromBackendToClientAngle(radianToDegree(this.hueAngle));
    };
}
